import AppRouter from "./app/router/AppRouter";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div>
      <AppRouter />
      <ToastContainer theme="colored" />
    </div>
  );
}

export default App;
